export const useProgress = (fetchingOutbound, fetchingInbound, fetchingHotelorPlans) => {
  const fetching = fetchingOutbound || fetchingInbound || fetchingHotelorPlans;
  let progressRate = 0;

  if (!fetchingOutbound) {
    progressRate += 25;
  }

  if (!fetchingInbound) {
    progressRate += 25;
  }

  if (!fetchingHotelorPlans) {
    progressRate += 25;
  }

  return { fetching, progressRate };
};